
<div class="asset-result-item" *ngIf="site" routerLink="/site-tree/{{site.mibId}}">
    <div class="col icon"><mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="factory"></mat-icon></div>
    <div class="col identifier-name">
    <div class="item">Name:</div>
    <div class="item">Country:</div>
    </div>
    <div class="col identifier-content">
        <div class="item">{{ site.name }}</div>
        <div class="item">{{ site.country || "Unknown" }}</div>
        </div>    
    <div class="col additional-name">
        <div class="item">Site ID:</div>
        <div class="item"></div>
    </div>
    <div class="col additional-content">
        <div class="item">{{ site.servIsId}}</div>
        <div class="item"></div>
    </div>
</div>

<div class="asset-result-item" *ngIf="!site">
    Error loading site search result.
</div>